module.exports = __webpack_public_path__ + "img/banner-tc4-m.c7e215f0.jpg";